import React from 'react';
import {Button, Modal} from "semantic-ui-react";
import CopyString from "./copyString";
import YMap from "./map";

const MapModal = ({onClose, open, address, coordinates}) => {
    return (
        <Modal
            className='map-modal'
            closeIcon
            onClose={onClose}
            open={open}
            size="tiny"
        >
            <Modal.Header>
                Карта
            </Modal.Header>
            <Modal.Content className='modal__content'>
                <div>
                    <YMap coordinates={coordinates}/>
                </div>
                <div>
                    <CopyString>{address}</CopyString>
                </div>
            </Modal.Content>
            <Modal.Actions className='modal__actions'>
                <Button onClick={onClose}>Закрыть</Button>
            </Modal.Actions>
        </Modal>
    );
};

export default MapModal;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/mapModal.jsx